import { createApp } from '@wu/widget-core';
import { Calculator } from './calculator';
import { meta } from './meta';

export default createApp(meta, Calculator);
